import { Navigate, useLocation } from 'react-router-dom';
import React, { FC } from 'react';
import { useAuthStore } from '../../store/authStore';
import { useLandingPageStore } from '../../store/landingPageStore';
import useSendLoginHours from '../../apiHooks/queries/loginHoursQuery/loginHoursQuery';
import { useOrganizationSettingsStore } from "../../store/organizationSettingsStore";
import { useGetIntegrations } from "../../apiHooks/queries/integrations/allIntegrations/useGetAllIntegrations";

interface ProtectedRouteProps {
  children: React.ReactElement<any, any> | null;
}

const ProtectedRoute: FC<ProtectedRouteProps> = ({ children }) => {
  const { isLoggedIn } = useAuthStore();
  const { landingPage } = useLandingPageStore();
  const { data: loginData } = useSendLoginHours(isLoggedIn);
  const organizationSettings = useOrganizationSettingsStore((state) => state.organizationSettings);
  const location = useLocation();
  const currentRoute = location.pathname;

  const { data: integrationsData, isLoading } = useGetIntegrations('GET_ALL_INTEGRATIONS');
  const integrations = integrationsData?.data?.data || {};

  const hasAnyIntegration = Object.values(integrations).some(Boolean);
  const isShopifyPage = currentRoute === '/shopify';
  const isIntegrationPage = currentRoute.startsWith('/integrations/ad-providers');
  const isUsersPage = currentRoute.startsWith('/administration/users');

  if (!isLoggedIn && !currentRoute.startsWith('/auth')) {
    return <Navigate to="/auth" />;
  }

  if (organizationSettings.shopifyEnabled && isLoggedIn && isLoading) {
    return null;
  }

  if (
      isLoggedIn &&
      organizationSettings.shopifyEnabled &&
      !hasAnyIntegration &&
      !isUsersPage &&
      !isShopifyPage &&
      !isIntegrationPage
  ) {
    return <Navigate to="/shopify" />;
  }

  if ((isLoggedIn && currentRoute.startsWith('/auth')) || (isLoggedIn && currentRoute === '/')) {
    return <Navigate to={`/${landingPage}`} />;
  }

  return children;
};

export default ProtectedRoute;
